export const EMPTY_OWNER =
  "please provide owner in load() initialization or you can set by calling raydium.setOwner(owner)";

export const EMPTY_CONNECTION =
  "please provide connection in load() initialization or set it by raydium.setConnection(connection)";
